import {Injectable} from '@angular/core';
import {Account} from "../../domain/model/account.model";
import {IApiAccount} from "../../../../../shared/infrastructure/dto/account-api.interface";
import {AccountFormattingPort} from "../../../../../shared/domain/ports/account-formatting.port";
import {AccountApiMapper} from "../mappers/account-api.mapper";

@Injectable({providedIn: 'root'})
export class AccountFormattingService implements AccountFormattingPort {

  toApiDto(account: Account): IApiAccount {
    return AccountApiMapper.toApi(account);
  }
}
